
















































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import {ValidationObserver} from "vee-validate"
import JdhBackButton from "@/design-system/shared/JdhBackButton.vue"
import {Location} from "vue-router"

/**
 * @status stable
 * @published 5.0.0
 * @changelog 5.0.0 Published.
 */
@Component({
    components: {JdhBackButton}
})
export default class JdsDraftingTable extends Vue {
    @Ref() observer!: InstanceType<typeof ValidationObserver>

    @Prop() backTo!: Location
    // @Prop({default: false, type: Boolean}) saving!: boolean
    saving = false
    failed = false

    // to avoid confusion, we don't show the pristine message until the first time the form is saved.
    hasBeenSavedOnce = false

    countProblems(state: Record<string, string[]>) {
        return Object.keys(state).filter(field => state[field].length).length
    }

    submit() {
        this.observer.validateWithInfo().then(state => {
            if (!state.isValid) {
                const firstError = Object.keys(state.errors).filter(field => state.errors[field].length)[0]
                const el = document.getElementById(firstError)
                if (firstError && el) {
                    el.scrollIntoView({ block: 'center', behavior: 'smooth'})
                }
            } else {
                this.saving = true
                this.failed = false
                /**
                 * Prompt a save event on the form. Be sure to call one of these; otherwise,
                 * the end user will see an endless saving indicator.
                 *
                 * @param {function} res Callback to call when the saving is complete.
                 * @param {function} err Callback to call if something goes wrong while saving.
                 */
                this.$emit('save', () => {
                    this.hasBeenSavedOnce = true
                    this.observer.reset()
                    this.saving = false
                }, () => {
                    this.observer.reset()
                    this.failed = true
                    this.saving = false
                })
            }
        })
    }

    jumpToError() {
        this.observer.validateWithInfo({ silent: true }).then(state => {
            if (!state.isValid) {
                const firstError = Object.keys(state.errors).filter(field => state.errors[field].length)[0]
                const el = document.getElementById(firstError)
                if (firstError && el) {
                    el.scrollIntoView({ block: 'center', behavior: 'smooth'})
                }
            }
        })
    }

    mounted() {
        document.addEventListener('keydown', this.saveShortcutListener);
    }

    beforeDestroy() {
        document.removeEventListener('keydown', this.saveShortcutListener);
    }

    saveShortcutListener(e: KeyboardEvent) {
        const isMacOS = window.navigator.platform.match('Mac');
        const isCmdS = e.code === 'KeyS' && e.metaKey;
        const isCtrlS = e.code === 'KeyS' && e.ctrlKey;
        const isSaveShortcut = isMacOS ? isCmdS : isCtrlS;

        if (!isSaveShortcut) {
            return;
        }

        e.preventDefault();

        if (this.saving) {
            return;
        }

        this.submit();
    }
}

